import { ref } from "vue";
import { defineStore } from "pinia";
import useMyFetch from "@stores/useMyFetch";
import type { MCampaignPush, MCampaignPushFailure } from "@/types";

export const useMCampaignPushesStore = defineStore("mCampaignPushes", () => {
  const pushes = ref<MCampaignPush[]>([]);
  const failuresByPushId = ref<Record<number, MCampaignPushFailure[]>>({});
  const expandedIds = ref<number[]>([]);
  const loading = ref(false);
  let campaignToken: string | null = null;

  const fetchFailures = async (pushId: number) => {
    const { data } = await useMyFetch(`/m_campaigns/${campaignToken}/pushes/${pushId}`).json<MCampaignPush>();
    failuresByPushId.value[pushId] = data.value?.failures ?? [];
  };

  const fetchPushes = async (token: string) => {
    campaignToken = token;
    loading.value = true;
    expandedIds.value = [];
    failuresByPushId.value = {};
    const { data } = await useMyFetch(`/m_campaigns/${token}/pushes`).json<{ m_campaign_pushes: MCampaignPush[] }>();
    pushes.value = data.value?.m_campaign_pushes ?? [];
    loading.value = false;
  };

  const toggle = (pushId: number) => {
    if (expandedIds.value.includes(pushId)) {
      expandedIds.value = expandedIds.value.filter((expandedId) => expandedId !== pushId);
      return;
    }

    expandedIds.value = [...expandedIds.value, pushId];
    if (!failuresByPushId.value[pushId]) fetchFailures(pushId);
  };

  return { pushes, failuresByPushId, expandedIds, loading, fetchPushes, toggle };
});
